import { h } from 'preact';
import StockDetails from '../stock-details';
import { isCurrency } from '../../lib/util.js';
import style from './style';
import cx from 'classnames';
import { containerSize } from '@cube/blocks';

export function DetailTable ({ quote, width, ...props }) {
	let fieldGroup1, fieldGroup2;
	if (isCurrency(quote)) {
		fieldGroup1 = ['open', 'prevClose', 'bid'];
		fieldGroup2 = ['ask', 'dayRange', '52WeekRange'];
	}
	else {
		fieldGroup1 = ['open', 'prevClose', 'bid', 'ask', 'dayRange', '52WeekRange'];
		fieldGroup2 = ['marketCap', 'profitOverEarnings', 'volume', 'averageVolume', 'dividend', 'yield'];
	}

	return (
		<span>
			<div class={cx(style.quotePanel, width > 600 && style.wide)}>
				<StockDetails
					fields={fieldGroup1}
					quote={quote}
					{...props}
				/>
			</div>
			<div class={cx(style.quotePanel, width > 600 && style.wide)}>
				<StockDetails
					fields={fieldGroup2}
					quote={quote}
					{...props}
				/>
			</div>
		</span>
	);
}

export default containerSize({ height: false })(DetailTable);
